module.exports = __webpack_public_path__ + "media/images/masks/icon-status-c971ca1909311eb4bd25cf62905f6d03.svg";